/**
 * @file useUserPasswordSetting.js
 * @description 密码设置页逻辑
 * @module features/user/composables/useUserPasswordSetting
 */

import { onMounted, ref } from 'vue'
import { updateUserPasswordApi } from '@/features/user/api/userApi'

export function useUserPasswordSetting() {
  const formData = ref({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  })
  const token = ref('')
  const passwordError = ref(false)
  const confirmPasswordError = ref(false)
  const popupMessage = ref('')
  const popupType = ref('')
  const showPopup = ref(false)

  function showPopupMessage(message, type) {
    popupMessage.value = message
    popupType.value = type
    showPopup.value = true
    setTimeout(() => {
      showPopup.value = false
    }, 2000)
  }

  function validatePasswords() {
    passwordError.value = false
    confirmPasswordError.value = false

    if (!formData.value.oldPassword) {
      passwordError.value = true
      showPopupMessage('旧密码不能为空', 'error')
      return false
    }
    if (!formData.value.newPassword) {
      passwordError.value = true
      showPopupMessage('新密码不能为空', 'error')
      return false
    }
    if (formData.value.newPassword !== formData.value.confirmPassword) {
      confirmPasswordError.value = true
      showPopupMessage('两次输入的新密码不一致', 'error')
      return false
    }
    return true
  }

  async function updatePassword() {
    const { oldPassword, newPassword } = formData.value
    if (!validatePasswords()) return

    try {
      const response = await updateUserPasswordApi({ oldPassword, newPassword })
      if (response.data.code === 200 || response.data.code === 0) {
        showPopupMessage('密码修改成功', 'success')
      } else {
        showPopupMessage(response.data.msg || '密码修改失败', 'error')
      }
    } catch (error) {
      showPopupMessage(
        error.response?.data?.msg || '网络错误，请稍后重试',
        'error'
      )
    }
  }

  onMounted(() => {
    token.value = JSON.parse(localStorage.getItem('user'))?.token || ''
    if (!token.value) {
      showPopupMessage('未找到用户授权信息，请登录后重试', 'error')
    }
  })

  return {
    formData,
    passwordError,
    confirmPasswordError,
    popupMessage,
    popupType,
    showPopup,
    validatePasswords,
    updatePassword,
  }
}
